// ------------------------------------
// Constants
// ------------------------------------
export const POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST =
  "POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST";
export const POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_SUCCESS =
  "POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_SUCCESS";
export const POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_FAILURE =
  "POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
// Caller passes `resolve` / `reject` callbacks; the saga invokes them when
// the PATCH settles. The dismiss UI is driven by the conflicts-get reducer's
// optimistic/revert actions — the slice owned by the success/failure actions
// here is intentionally reserved for future per-ack UI feedback (e.g. a
// spinner on the row, surfacing the last-acked id, an inline error chip).
export function request(id, resolve, reject) {
  return {
    type: POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST,
    id,
    resolve,
    reject,
  };
}

export function requestSuccess(id, data) {
  return {
    type: POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_SUCCESS,
    id,
    data,
  };
}

export function requestFailure(id, error) {
  return {
    type: POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_FAILURE,
    id,
    error,
  };
}
